import { render, staticRenderFns } from "./EditCompanyEmisorasForm.vue?vue&type=template&id=4c97d2b4"
import script from "./EditCompanyEmisorasForm.vue?vue&type=script&lang=js"
export * from "./EditCompanyEmisorasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports